import { EconomicsSettingsFacilityInputBase } from './base/economics-settings-facility-input-base';

export class EconomicsSettingsFacilityInput extends EconomicsSettingsFacilityInputBase { }